import { Box, Grid, Typography } from '@mui/material';
import { ProcurementOverviewItem, procurementOverviewItems } from './data';

const badgeColors = ['#0F5D85', '#005FCC'];

const Item = ({ item, isExpanded }: { item: ProcurementOverviewItem; isExpanded?: boolean }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        boxShadow: '0px 0px 40px 0px #0017721A',
        p: { xs: 2, sm: 2, md: 2, lg: 3, xl: 3 },
        borderRadius: '20px',
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        display={'flex'}
        gap={3}
        justifyContent={'space-between'}
        height={'100%'}
        sx={{
          flexDirection: { xs: 'column', sm: 'column', md: 'column', lg: isExpanded ? 'row' : 'column' },
          xl: isExpanded ? 'row' : 'column',
        }}
      >
        <Grid item xs={12} sm={12} md={12} lg={isExpanded ? 6 : 12} xl={isExpanded ? 6 : 12}>
          <Box display={'flex'} gap={1.5} flexWrap={'wrap'}>
            {item.badges.map((badge, index) => (
              <Typography
                key={badge}
                fontSize={{
                  xs: 8,
                  lg: 12,
                }}
                fontWeight={700}
                textTransform={'uppercase'}
                color='#fff'
                sx={{
                  backgroundColor: badgeColors[index % badgeColors.length],
                  display: 'inline-block',
                  borderRadius: '30px',
                  py: 1,
                  px: 2,
                  letterSpacing: '2px',
                }}
              >
                {badge}
              </Typography>
            ))}
          </Box>

          <Typography
            color='#070A0D'
            fontWeight={600}
            fontSize={{ xs: 18, lg: 24 }}
            mt={2}
            mb={1}
            lineHeight={1.25}
            component='h4'
          >
            {item.title}
          </Typography>

          <Typography color='#1D2935' fontSize={{ xs: 12, lg: 16 }} fontWeight={400}>
            {item.description}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={isExpanded ? 6 : 12} xl={isExpanded ? 6 : 12}>
          <img
            src={item.image}
            alt={item.title}
            style={{
              display: 'block',
              width: '100%',
              height: 'auto',
              aspectRatio: '496 / 220',
              borderRadius: '10px',
              objectFit: 'cover',
              objectPosition: 'center',
            }}
          />
        </Grid>
      </Box>
    </Box>
  );
};

const ProcurementOverview = () => {
  return (
    <div
      style={{
        paddingBlock: '4rem',
        marginBlock: '2rem',
        background:
          'linear-gradient(90deg, rgba(0, 149, 255, 0.05) 0%, rgba(255, 0, 140, 0.05) 49.04%, rgba(255, 166, 0, 0.05) 100%), linear-gradient(180deg, rgba(255, 255, 255, 0) 63.65%, #FFFFFF 100.78%), linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 46.54%)',
      }}
    >
      <div className='page__content'>
        <Typography
          color='#3A3E50'
          fontWeight={600}
          fontSize={{ xs: 26, lg: 44 }}
          textAlign={'center'}
          mb={4}
          mx={'auto'}
          maxWidth={'30ch'}
          lineHeight={1}
          component='h3'
        >
          End-to-End Procurement
          <br />
          One Seamless SaaS Solution
        </Typography>

        <Typography
          color='#1D2935'
          lineHeight={1.5}
          fontSize={{ xs: 12, lg: 16 }}
          fontWeight={400}
          textAlign={'center'}
          maxWidth={'500px'}
          mx={'auto'}
          mb={4}
        >
          Gain full visibility, automate workflows, and connect instantly with buyers and sellers - all in one
          intuitive, AI-enhanced platform
        </Typography>

        <Grid container spacing={3}>
          {procurementOverviewItems.map((item, index) => {
            const isTwoCols = index % 3 !== 0;

            return (
              <Grid item key={item.title} xs={12} sm={12} md={12} lg={isTwoCols ? 6 : 12} xl={isTwoCols ? 6 : 12}>
                <Item item={item} isExpanded={!isTwoCols} />
              </Grid>
            );
          })}
        </Grid>
      </div>
    </div>
  );
};

export default ProcurementOverview;
